import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function authHeaders() {
  const token = localStorage.getItem("brox_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ceva n-a funcționat. Te rugăm să încerci din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadCsv(url, fallbackName) {
  const { data, headers } = await api.get(url, { responseType: "blob", headers: authHeaders() });
  const cd = headers?.["content-disposition"] || "";
  const m = cd.match(/filename="?([^";]+)"?/);
  const name = m ? m[1] : fallbackName;
  const blobUrl = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

export async function postWithRetry(url, body, retries = 2) {
  for (let attempt = 0; ; attempt++) {
    try {
      return await api.post(url, body);
    } catch (e) {
      if (e.response || attempt >= retries) throw e;
      await new Promise((r) => setTimeout(r, 1200 * (attempt + 1)));
    }
  }
}

export default api;
